import { createContext } from 'react';

export const NavigationHelperContext = createContext({
    currentScreen: '',
    setCurrentScreen: () => {},
    prevScreen: ''
});
